const listThematic = {
  FirstForm: 'Mon état général',
  SecondForm: 'Ma respiration et mon souffle',
  ThirdForm: 'La santé de mes organes',
  FourthForm: 'Ma santé psychologique',
}

export default listThematic
